import Service from '@/services/abstract/service'

export default class Gerente extends Service {
  constructor() {
    super()
    this._leadRef = this._db.collection(`${this._prefix}-leads`)
    this._rankRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Rank`
    )
  }

  async getLeads(dateStart, dateEnd) {
    try {
      this._loading.setLoading(true, 'Carregando Leads')

      const dataFim = new Date(dateEnd)
      dataFim.setDate(dataFim.getDate() + 1)
      dataFim.setHours(23, 59, 59)

      const dataInicio = new Date(dateStart)
      dataInicio.setDate(dataInicio.getDate() + 1)
      dataInicio.setHours(0)

      const response = await this._leadRef
        .where('empresa', '==', this._empresaPrincipal)
        .where('dataCriacao', '>=', dataInicio)
        .where('dataCriacao', '<=', dataFim)
        .get()

      let leads = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          leads.push(doc.data())
        }
      }

      return Promise.resolve(leads)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getRanks() {
    try {
      this._loading.setLoading(true, 'Carregando Rank')

      const dateStart = new Date()
      dateStart.setDate(1)
      const date = new Date()
      date.setMonth(date.getMonth() + 1, 0)
      const dateEnd = date

      const response = await this._rankRef
        .where('dataUltimaAtualizacao', '>=', dateStart)
        .where('dataUltimaAtualizacao', '<=', dateEnd)
        .get()

      let rank = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          rank.push(doc.data())
        }
      }

      return Promise.resolve(rank)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getHistoricoRanks() {
    try {
      this._loading.setLoading(true, 'Carregando Historico do Rank')

      let dateStart = new Date()
      dateStart.setMonth(dateStart.getMonth() - 6)
      let dateEnd = new Date()

      let ranks = new Array()
      let response = await this._rankRef
        .where('empresa', '==', this._empresaPrincipal)
        .where('dataUltimaAtualizacao', '>=', dateStart)
        .where('dataUltimaAtualizacao', '<=', dateEnd)
        .orderBy('dataUltimaAtualizacao', 'asc')
        .get()

      if (!response.empty) {
        for (let doc of response.docs) {
          ranks.push(doc.data())
        }
      }

      return Promise.resolve(ranks)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
}
